(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var heroTitle = document.querySelector(".works-hero__title");
    if (heroTitle && window.DNB && typeof window.DNB.revealText === "function") {
      var heroLines = Array.prototype.slice.call(
        heroTitle.querySelectorAll(".hero__line")
      );
      var heroTargets = heroLines.length ? heroLines : [heroTitle];
      window.DNB.revealText(heroTargets, {
        stagger: 0.18,
        duration: 0.9,
        ease: "expo.out"
      });
    }

    var root = document.querySelector("[data-works]");
    if (!root) {
      return;
    }

    var magneticButtons = document.querySelectorAll("[data-magnetic]");
    magneticButtons.forEach(function (button) {
      button.addEventListener("mousemove", function (event) {
        var rect = button.getBoundingClientRect();
        var relX = (event.clientX - rect.left - rect.width / 2) / rect.width;
        var relY = (event.clientY - rect.top - rect.height / 2) / rect.height;
        var x = relX * 16;
        var y = relY * 16;
        button.style.transform = "translate(" + x + "px, " + y + "px)";
      });

      button.addEventListener("mouseleave", function () {
        button.style.transform = "";
      });
    });

    var list = document.querySelector("[data-works-portfolio-list]");
    var moreButton = document.querySelector("[data-works-more]");
    var tagsWrap = document.querySelector("[data-works-tags]");
    var tagsList = document.querySelector("[data-works-tags-list]");
    var tagsDropdown = document.querySelector("[data-works-tags-dropdown]");
    var tagsToggle = document.querySelector("[data-works-tag-toggle]");
    var tagsOptions = document.querySelector("[data-works-tag-options]");
    var industriesWrap = document.querySelector("[data-works-industries]");
    var industriesToggle = document.querySelector("[data-works-industry-toggle]");
    var industriesOptions = document.querySelector("[data-works-industry-options]");

    if (
      !list ||
      !tagsWrap ||
      !tagsList ||
      !tagsDropdown ||
      !tagsToggle ||
      !tagsOptions ||
      !industriesWrap ||
      !industriesToggle ||
      !industriesOptions
    ) {
      return;
    }

    var perPage = 7;
    var items = [];
    var filteredItems = [];
    var visibleCount = 0;
    var selectedTags = new Set();
    var selectedIndustries = new Set();
    var allTags = [];
    var allIndustries = [];
    var revealQueue = [];
    var revealRunning = false;
    var worksInView = false;
    var filtersRevealStarted = false;
    var filtersReady = false;
    var revealAfterLoadPending = false;
    var filtersAfterLoadPending = false;
    var initialRevealPending = true;
    var moreButtonLocked = true;

    var setFiltersHidden = function (hidden) {
      var action = hidden ? "add" : "remove";
      if (tagsWrap) {
        tagsWrap.classList[action]("is-hidden");
        if (hidden) {
          tagsWrap.setAttribute("aria-hidden", "true");
        } else {
          tagsWrap.removeAttribute("aria-hidden");
        }
      }
      if (industriesWrap) {
        industriesWrap.classList[action]("is-hidden");
        if (hidden) {
          industriesWrap.setAttribute("aria-hidden", "true");
        } else {
          industriesWrap.removeAttribute("aria-hidden");
        }
      }
    };

    var setMoreHidden = function (hidden) {
      if (!moreButton) {
        return;
      }
      if (hidden) {
        moreButton.classList.add("portfolio__more--hidden");
        moreButton.setAttribute("aria-hidden", "true");
        moreButton.setAttribute("disabled", "disabled");
        moreButton.style.display = "none";
      } else {
        moreButton.classList.remove("portfolio__more--hidden");
        moreButton.removeAttribute("aria-hidden");
        moreButton.removeAttribute("disabled");
        moreButton.style.display = "";
      }
    };

    var updateMoreButton = function () {
      if (!moreButton) {
        return;
      }
      if (visibleCount >= filteredItems.length) {
        setMoreHidden(true);
        return;
      }
      if (moreButtonLocked) {
        setMoreHidden(true);
        return;
      }
      setMoreHidden(false);
    };

    var revealFilters = function () {
      if (
        !filtersAfterLoadPending &&
        window.DNB &&
        !window.DNB.loadingComplete &&
        typeof window.DNB.onLoadComplete === "function"
      ) {
        filtersAfterLoadPending = true;
        window.DNB.onLoadComplete(function () {
          filtersAfterLoadPending = false;
          revealFilters();
        });
        return;
      }

      if (filtersRevealStarted || filtersReady) {
        return;
      }
      filtersRevealStarted = true;

      var finalize = function () {
        filtersReady = true;
        if (worksInView) {
          startReveal();
        }
      };

      if (window.gsap) {
        window.gsap.set([tagsWrap, industriesWrap], { autoAlpha: 0, y: 12 });
      }

      setFiltersHidden(false);

      if (!window.gsap) {
        finalize();
        return;
      }

      window.gsap
        .timeline({ onComplete: finalize })
        .to(tagsWrap, {
          autoAlpha: 1,
          y: 0,
          duration: 0.35,
          ease: "power2.out"
        })
        .to(
          industriesWrap,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.35,
            ease: "power2.out"
          },
          ">0.1"
        );
    };

    var handleRevealComplete = function () {
      if (!initialRevealPending) {
        return;
      }
      initialRevealPending = false;
      moreButtonLocked = false;
      updateMoreButton();
    };

    setFiltersHidden(true);
    setMoreHidden(true);

    var applyTextAnimations = function (scope) {
      if (window.DNB && typeof window.DNB.textOpacityInit === "function") {
        window.DNB.textOpacityInit(scope);
      }
      if (window.DNB && typeof window.DNB.textOpacityV2Init === "function") {
        window.DNB.textOpacityV2Init(scope);
      }
    };

    var revealBodyText = function (card, onComplete) {
      if (!card) {
        if (typeof onComplete === "function") {
          onComplete();
        }
        return;
      }

      var targets = Array.prototype.slice.call(
        card.querySelectorAll(
          ".portfolio-card__title, .portfolio-card__desc"
        )
      ).filter(function (el) {
        if (el.dataset.dnbRevealPlayed === "true") {
          return false;
        }
        el.dataset.dnbRevealPlayed = "true";
        return true;
      });

      var finalize = function () {
        targets.forEach(function (target) {
          var inner = target.querySelector(".dnb-reveal__inner");
          if (inner) {
            inner.style.opacity = "";
            inner.style.transform = "";
          } else {
            target.style.opacity = "";
            target.style.transform = "";
          }
        });
        if (typeof onComplete === "function") {
          onComplete();
        }
      };

      if (!targets.length || !window.DNB || typeof window.DNB.revealText !== "function") {
        finalize();
        return;
      }

      var timeline = window.DNB.revealText(targets, {
        duration: 0.3,
        stagger: 0,
        ease: "expo.out",
        onComplete: finalize
      });

      if (!timeline) {
        finalize();
      }
    };

    var prepareBodyReveal = function (card) {
      if (!card || !window.DNB || typeof window.DNB.prepareReveal !== "function") {
        return;
      }

      var targets = card.querySelectorAll(
        ".portfolio-card__title, .portfolio-card__desc"
      );
      targets.forEach(function (target) {
        if (target.dataset.dnbRevealPrepared === "true") {
          return;
        }
        target.dataset.dnbRevealPrepared = "true";
        var inner = window.DNB.prepareReveal(target);
        if (inner) {
          inner.style.opacity = "0";
        }
      });
    };

    var runRevealBatch = function (targets) {
      if (!targets.length) {
        revealRunning = false;
        handleRevealComplete();
        return;
      }

      if (!window.gsap) {
        targets.forEach(function (target) {
          target.style.opacity = "";
          target.style.transform = "";
          var mediaContent = target.querySelector(".portfolio-card__media-content");
          if (mediaContent) {
            mediaContent.style.transform = "";
          }
        });
        revealRunning = false;
        handleRevealComplete();
        return;
      }

      var revealNext = function (index) {
        if (index >= targets.length) {
          revealRunning = false;
          if (revealQueue.length) {
            startReveal();
          } else {
            handleRevealComplete();
          }
          return;
        }

        var target = targets[index];
        var mediaContent = target.querySelector(".portfolio-card__media-content");
        window.gsap.to(target, {
          opacity: 1,
          scale: 1,
          duration: 0.3,
          ease: "power3.out",
          onComplete: function () {
            revealBodyText(target.closest(".portfolio-card"), function () {
              revealNext(index + 1);
            });
          }
        });

        if (mediaContent) {
          window.gsap.to(mediaContent, {
            scale: 1,
            duration: 0.3,
            ease: "power3.out"
          });
        }
      };

      revealNext(0);
    };

    var startReveal = function () {
      if (
        !revealAfterLoadPending &&
        window.DNB &&
        !window.DNB.loadingComplete &&
        typeof window.DNB.onLoadComplete === "function"
      ) {
        revealAfterLoadPending = true;
        window.DNB.onLoadComplete(function () {
          revealAfterLoadPending = false;
          startReveal();
        });
        return;
      }

      if (revealRunning || !worksInView || !filtersReady || !revealQueue.length) {
        return;
      }

      revealRunning = true;
      var batch = revealQueue.slice();
      revealQueue = [];
      runRevealBatch(batch);
    };

    var queueReveal = function (targets) {
      if (!targets || !targets.length) {
        return;
      }

      var newTargets = [];
      targets.forEach(function (target) {
        if (target.dataset.worksRevealQueued === "true") {
          return;
        }
        target.dataset.worksRevealQueued = "true";
        if (window.gsap) {
          target.style.opacity = "0";
          target.style.transform = "scale(0.3)";
          target.style.transformOrigin = "center";
          var mediaContent = target.querySelector(".portfolio-card__media-content");
          if (mediaContent) {
            mediaContent.style.transform = "scale(1.7)";
            mediaContent.style.transformOrigin = "center";
          }
        }
        newTargets.push(target);
      });

      if (!newTargets.length) {
        return;
      }

      revealQueue = revealQueue.concat(newTargets);
      startReveal();
    };

    var normalizeList = function (value) {
      if (Array.isArray(value)) {
        return value
          .map(function (entry) {
            return String(entry || "").trim();
          })
          .filter(Boolean);
      }
      if (typeof value === "string") {
        return value
          .split(",")
          .map(function (entry) {
            return String(entry || "").trim();
          })
          .filter(Boolean);
      }
      return [];
    };

    var normalizeSize = function (value) {
      var size = value ? String(value).trim().toLowerCase() : "";
      if (size === "small" || size === "medium" || size === "large") {
        return size;
      }
      return "medium";
    };

    var formatLabel = function (value) {
      var text = String(value || "").trim();
      if (!text) {
        return "";
      }
      var first = text.charAt(0);
      if (first === first.toLowerCase()) {
        return first.toUpperCase() + text.slice(1);
      }
      return text;
    };

    var isVideoFile = function (value) {
      return String(value || "").toLowerCase().endsWith(".mp4");
    };

    var getMediaInfo = function (item) {
      if (!item) {
        return null;
      }

      if (item.video) {
        var videoSrc = String(item.video || "").trim();
        if (videoSrc) {
          return { src: videoSrc, isVideo: true };
        }
      }

      if (item.image) {
        var imageSrc = String(item.image || "").trim();
        if (imageSrc) {
          return { src: imageSrc, isVideo: false };
        }
      }

      if (Array.isArray(item.images) && item.images.length) {
        var first = String(item.images[0] || "").trim();
        if (first) {
          return { src: first, isVideo: isVideoFile(first) };
        }
      }

      if (item.images) {
        var fallback = String(item.images || "").trim();
        if (fallback) {
          return { src: fallback, isVideo: isVideoFile(fallback) };
        }
      }

      return null;
    };

    var resolveMediaSrc = function (src, isVideo) {
      var lower = String(src || "").toLowerCase();
      var hasPath = /^[a-z]+:\/\//.test(lower) || String(src).indexOf("/") !== -1;
      var basePath = isVideo ? "/assets/videos/" : "/assets/images/";
      return hasPath ? src : basePath + src;
    };

    var getTags = function (item) {
      return normalizeList(item && item.tags);
    };

    var getIndustries = function (item) {
      if (!item) {
        return [];
      }
      var value = item.industries || item.industry;
      return normalizeList(value).map(formatLabel).filter(Boolean);
    };

    var createCard = function (item) {
      var url = item && item.url ? String(item.url || "").trim() : "";
      var article = url ? document.createElement("a") : document.createElement("article");
      article.className = "portfolio-card";
      article.classList.add(normalizeSize(item && item.size));
      if (url) {
        article.href = url;
        if (item && item.title) {
          article.setAttribute("aria-label", item.title);
        }
      }

      var media = document.createElement("div");
      media.className = "portfolio-card__media";
      media.setAttribute("aria-hidden", "true");

      var mediaInfo = getMediaInfo(item);
      var hasFiles = !!(mediaInfo && mediaInfo.src);
      if (!hasFiles && item && item.mediaClass) {
        var mediaClass = String(item.mediaClass || "").trim();
        if (mediaClass && mediaClass.indexOf(" ") === -1 && mediaClass.indexOf(",") === -1) {
          media.classList.add(mediaClass);
        }
      }

      if (hasFiles) {
        var src = resolveMediaSrc(mediaInfo.src, mediaInfo.isVideo);
        if (mediaInfo.isVideo) {
          var video = document.createElement("video");
          video.className = "portfolio-card__media-content";
          video.src = src; 
          video.autoplay = true;
          video.muted = true;
          video.loop = true; 
          video.playsInline = true;
          video.preload = "metadata";
          media.appendChild(video);
        } else {
          var img = document.createElement("img");
          img.className = "portfolio-card__media-content";
          img.src = src;
          img.alt = item.title || "";
          img.loading = "lazy";
          img.decoding = "async";
          media.appendChild(img);
        }
      } else {
        media.style.background =
          "#000000";
          //"linear-gradient(140deg,#062420 0,#0b2f2a 45%,#0f3a33 100%)";
      }
      if (item && item.bgColor) {
        media.style.background = item.bgColor;
      }
      var tagsList = getTags(item);
      if (tagsList.length) {
        var tags = document.createElement("ul");
        tags.className = "portfolio-card__tags";
        tagsList.forEach(function (tag) {
          var li = document.createElement("li");
          li.textContent = tag;
          tags.appendChild(li);
        });
        media.appendChild(tags);
      }

      var body = document.createElement("div");
      body.className = "portfolio-card__body";

      if (item && item.title) {
        var title = document.createElement("h3");
        title.className = "portfolio-card__title";
        title.setAttribute("data-text-opacity-v2", "");
        title.textContent = item.title;
        body.appendChild(title);
      }

      if (item && item.description) {
        var desc = document.createElement("p");
        desc.className = "portfolio-card__desc";
        desc.setAttribute("data-text-opacity", "");
        desc.innerHTML = String(item.description || "");
        body.appendChild(desc);
      }

      

      article.appendChild(media);
      article.appendChild(body);
      prepareBodyReveal(article);
      return article;
    };

    var collectTags = function (data) {
      var seen = new Set();
      var tags = [];
      data.forEach(function (item) {
        var list = getTags(item);
        if (!list.length) {
          return;
        }
        list.forEach(function (tag) {
          var value = String(tag || "").trim();
          if (!value || seen.has(value)) {
            return;
          }
          seen.add(value);
          tags.push(value);
        });
      });
      return tags;
    };

    var collectIndustries = function (data) {
      var seen = new Set();
      var industries = [];
      data.forEach(function (item) {
        var list = getIndustries(item);
        if (!list.length) {
          return;
        }
        list.forEach(function (industry) {
          var value = String(industry || "").trim();
          if (!value || seen.has(value)) {
            return;
          }
          seen.add(value);
          industries.push(value);
        });
      });
      return industries;
    };

    var filterByTags = function (data, tagsSet) {
      if (!tagsSet.size) {
        return data;
      }
      var tags = Array.from(tagsSet);
      return data.filter(function (item) {
        var list = getTags(item);
        if (!list.length) {
          return false;
        }
        return tags.every(function (tag) {
          return list.indexOf(tag) !== -1;
        });
      });
    };

    var filterByIndustries = function (data, industriesSet) {
      if (!industriesSet.size) {
        return data;
      }
      return data.filter(function (item) {
        var list = getIndustries(item);
        if (!list.length) {
          return false;
        }
        return list.some(function (industry) {
          return industriesSet.has(industry);
        });
      });
    };

    var renderTags = function (availableTags) {
      tagsList.innerHTML = "";
      tagsOptions.innerHTML = "";

      var listFragment = document.createDocumentFragment();
      allTags.forEach(function (tag) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "works-filters__tag";
        button.textContent = tag;
        button.setAttribute("data-tag", tag);
        button.setAttribute("aria-pressed", selectedTags.has(tag) ? "true" : "false");

        var isAvailable = availableTags.indexOf(tag) !== -1;
        if (selectedTags.has(tag)) {
          button.classList.add("is-selected");
        } else if (!isAvailable) {
          button.disabled = true;
        }

        listFragment.appendChild(button);
      });

      if (selectedTags.size) {
        var clearButton = document.createElement("button");
        clearButton.type = "button";
        clearButton.className = "works-filters__tag works-filters__tag--clear";
        clearButton.textContent = "Clear All";
        clearButton.setAttribute("data-clear-tags", "");
        listFragment.appendChild(clearButton);
      }

      tagsList.appendChild(listFragment);

      var dropdownFragment = document.createDocumentFragment();
      var allOption = document.createElement("button");
      allOption.type = "button";
      allOption.className = "works-filters__option";
      allOption.textContent = "All Works";
      allOption.setAttribute("data-tag", "__all");
      allOption.setAttribute("aria-selected", selectedTags.size ? "false" : "true");
      if (!selectedTags.size) {
        allOption.classList.add("is-selected");
      }
      dropdownFragment.appendChild(allOption);

      allTags.forEach(function (tag) {
        var option = document.createElement("button");
        option.type = "button";
        option.className = "works-filters__option";
        option.textContent = tag;
        option.setAttribute("data-tag", tag);
        option.setAttribute("aria-selected", selectedTags.has(tag) ? "true" : "false");

        var isAvailable = availableTags.indexOf(tag) !== -1;
        if (selectedTags.has(tag)) {
          option.classList.add("is-selected");
        } else if (!isAvailable) {
          option.disabled = true;
        }

        dropdownFragment.appendChild(option);
      });

      tagsOptions.appendChild(dropdownFragment);

      if (tagsToggle) {
        var setToggleLabel = function (suffix) {
          tagsToggle.innerHTML = "";
          var strong = document.createElement("strong");
          strong.textContent = "Filter : ";
          tagsToggle.appendChild(strong);
          tagsToggle.appendChild(document.createTextNode(suffix));
        };

        if (!selectedTags.size) {
          setToggleLabel("All Works");
        } else {
          var selectedList = allTags.filter(function (tag) {
            return selectedTags.has(tag);
          });
          if (selectedList.length === 1) {
            setToggleLabel(selectedList[0]);
          } else {
            setToggleLabel(selectedTags.size + " selected");
          }
        }
      }
    };

    var renderIndustries = function (availableIndustries) {
      industriesOptions.innerHTML = "";

      var fragment = document.createDocumentFragment();
      var allOption = document.createElement("button");
      allOption.type = "button";
      allOption.className = "works-filters__option";
      allOption.textContent = "All";
      allOption.setAttribute("data-industry", "__all");
      allOption.setAttribute("aria-selected", selectedIndustries.size ? "false" : "true");
      if (!selectedIndustries.size) {
        allOption.classList.add("is-selected");
      }
      fragment.appendChild(allOption);

      allIndustries.forEach(function (industry) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "works-filters__option";
        button.textContent = industry;
        button.setAttribute("data-industry", industry);
        button.setAttribute("aria-selected", selectedIndustries.has(industry) ? "true" : "false");

        var isAvailable = availableIndustries.indexOf(industry) !== -1;
        if (selectedIndustries.has(industry)) {
          button.classList.add("is-selected");
        } else if (!isAvailable) {
          button.disabled = true;
        }

        fragment.appendChild(button);
      });

      industriesOptions.appendChild(fragment);
      industriesToggle.textContent = selectedIndustries.size
        ? "Industries (" + selectedIndustries.size + ")"
        : "Industries";
    };

    var renderNext = function () {
      var nextItems = filteredItems.slice(visibleCount, visibleCount + perPage);
      if (!nextItems.length) {
        updateMoreButton();
        return;
      }

      var fragment = document.createDocumentFragment();
      nextItems.forEach(function (item) {
        fragment.appendChild(createCard(item));
      });

      list.appendChild(fragment);
      visibleCount += nextItems.length;

      updateMoreButton();

      applyTextAnimations(list);
      var newMedia = Array.prototype.slice.call(
        list.querySelectorAll(".portfolio-card__media")
      );
      queueReveal(newMedia);
      window.requestAnimationFrame(function () {
        if (window.ScrollTrigger) {
          window.ScrollTrigger.refresh();
        }
        if (window.DNB && window.DNB.locoScroll) {
          window.DNB.locoScroll.update();
        }
      });
    };

    var applyFilters = function () {
      var itemsMatchingTags = filterByTags(items, selectedTags);
      var itemsMatchingIndustries = filterByIndustries(items, selectedIndustries);

      var availableIndustries = collectIndustries(itemsMatchingTags);
      var availableTags = collectTags(itemsMatchingIndustries);

      renderTags(availableTags);
      renderIndustries(availableIndustries);

      if (!filtersRevealStarted && !filtersReady) {
        revealFilters();
      }

      filteredItems = filterByIndustries(itemsMatchingTags, selectedIndustries);
      list.innerHTML = "";
      revealQueue = [];
      revealRunning = false;
      visibleCount = 0;
      renderNext();
    };

    tagsWrap.addEventListener("click", function (event) {
      var button = event.target.closest("button");
      if (!button || button.disabled) {
        return;
      } 

      if (button.hasAttribute("data-clear-tags")) {
        selectedTags.clear();
        applyFilters(); 
        return;
      }

      var tag = button.getAttribute("data-tag");
      if (!tag) {
        return;
      }

      if (tag === "__all") {
        selectedTags.clear();
        applyFilters();
        return;
      }

      if (selectedTags.has(tag)) {
        selectedTags.delete(tag);
      } else {
        selectedTags.add(tag);
      }
      applyFilters();
    });

    var closeTagsDropdown = function () {
      if (!tagsDropdown || !tagsToggle) {
        return;
      }
      tagsDropdown.classList.remove("is-open");
      tagsToggle.setAttribute("aria-expanded", "false");
    };

    var closeIndustriesDropdown = function () {
      if (!industriesWrap || !industriesToggle) {
        return;
      }
      industriesWrap.classList.remove("is-open");
      industriesToggle.setAttribute("aria-expanded", "false");
    };

    tagsToggle.addEventListener("click", function () {
      closeIndustriesDropdown();
      var isOpen = tagsDropdown.classList.toggle("is-open");
      tagsToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    industriesToggle.addEventListener("click", function () {
      closeTagsDropdown();
      var isOpen = industriesWrap.classList.toggle("is-open");
      industriesToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    industriesOptions.addEventListener("click", function (event) {
      var button = event.target.closest("button");
      if (!button || button.disabled) {
        return;
      }

      var industry = button.getAttribute("data-industry");
      if (!industry) {
        return;
      }

      if (industry === "__all") {
        selectedIndustries.clear();
      } else if (selectedIndustries.has(industry)) {
        selectedIndustries.delete(industry); 
      } else {
        selectedIndustries.add(industry);
      }

      applyFilters();
    });

    document.addEventListener("click", function (event) {
      if (
        (tagsDropdown && tagsDropdown.contains(event.target)) ||
        industriesWrap.contains(event.target)
      ) {
        return;
      }
      closeTagsDropdown();
      closeIndustriesDropdown();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }
      closeTagsDropdown();
      closeIndustriesDropdown();
    });

    if (window.gsap && window.ScrollTrigger) {
      var revealTrigger = {
        trigger: list,
        start: "top 70%",
        once: true,
        onEnter: function () {
          worksInView = true;
          startReveal();
        }
      };

      if (window.DNB && window.DNB.scroller) {
        revealTrigger.scroller = window.DNB.scroller;
      }

      window.ScrollTrigger.create(revealTrigger);
    } else if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              worksInView = true;
              startReveal();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(list);
    } else {
      worksInView = true;
    }

    if (moreButton) {
      moreButton.addEventListener("click", function (event) {
        event.preventDefault();
        renderNext();
      });
    }

    // console.log("[loader] fetch start", "/Works-service");
    var request = fetch("/Works-service")
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Portfolio data not found");
        }
        return response.json();
      })
      .then(function (data) {
        // console.log("[loader] fetch success", "/Works-service", {
        //   items: Array.isArray(data && data.data) ? data.data.length : null
        // });
        if (!Array.isArray(data.data)) {
          return;
        }
        items = data.data;
        allTags = collectTags(items);
        allIndustries = collectIndustries(items);
        worksInView = true;
        applyFilters();
      })
      .catch(function (error) {
        // console.log("[loader] fetch failed", "/Works-service", error);
        setMoreHidden(true);
      });

    if (window.DNB && typeof window.DNB.registerLoadTask === "function") {
      window.DNB.registerLoadTask(request);
    }
  });
})();
